export default function dateComparator(filterLocalDateAtMidnight, cellValue) {
  const dateAsString = cellValue
  if (dateAsString === null) {
    return -1
  }

  if (filterLocalDateAtMidnight === null) {
    return 1
  }
  // Dates are stored as yyyy-mm-dd
  // We create a Date object for comparison against the filter date
  const cellDate = dateFromString(dateAsString)

  // Now that both parameters are Date objects, we can compare
  if (cellDate < filterLocalDateAtMidnight) {
    return -1
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1
  }
  return 0
}

const dateFromString = (dateString) => {
  const dateParts = dateString.split("-")
  const day = Number(dateParts[2])
  const month = Number(dateParts[1]) - 1
  const year = Number(dateParts[0])
  return new Date(year, month, day)
}
